import { render, staticRenderFns } from "./car-buy-upper-price.vue?vue&type=template&id=6e45249c&"
import script from "./car-buy-upper-price.vue?vue&type=script&lang=js&"
export * from "./car-buy-upper-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TippyQuestion: require('/var/www/components/tippy/tippy-question.vue').default,DiscountChip: require('/var/www/components/DiscountChip/index.vue').default})
